import { Button } from "react-bootstrap";
import { Order } from "src/app/types/orders/order";

const OrdersList = ({
    selectedOrderId,
    setSelectedOrderId,
    orders,
}: {
    orders: Order[];
    selectedOrderId: number;
    setSelectedOrderId: (id: number) => void;
}) => {
    return (
        <div className="order-wrapper">
            <div className="orders">
                {orders.map((el, index) => (
                    <div
                        className={`order-box ${selectedOrderId === el.id ? "selected" : ""}`}
                        key={index}
                        onClick={() => setSelectedOrderId(el.id)}
                    >
                        <div>
                            <b>Keyword: </b>
                            {el.keywords ? el.keywords[0] : ""}
                        </div>
                        <div className="w-100">
                            <b>URL: </b>
                            {el.url}
                        </div>
                    </div>
                ))}
            </div>
            <Button style={{ width: "fit-content" }} onClick={() => setSelectedOrderId(-1)}>
                Check All Data
            </Button>
        </div>
    );
};

export default OrdersList;
